package com.banyan.flightviewer.web.components

import com.banyan.flightviewer.state.AtcStreamStatus
import com.banyan.flightviewer.web.dom.bindFlow
import com.banyan.flightviewer.web.dom.button
import com.banyan.flightviewer.web.dom.div
import com.banyan.flightviewer.web.dom.onClick
import com.banyan.flightviewer.web.dom.span
import com.banyan.flightviewer.web.state.WebAppContainer
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event

/**
 * Bottom bar that appears whenever an ATC stream is selected. Shows the
 * airport + feed name, current status, volume slider, and a stop button.
 */
fun mountAtcPlayerBar(parent: org.w3c.dom.Element, app: WebAppContainer) {
    val container = parent.div(className = "fv-atc")
    container.asDynamic().style.display = "none"

    val title = container.span(className = "fv-atc__title")
    val statusSpan = container.span(className = "fv-atc__status")

    val volSlider = document.createElement("input") as HTMLInputElement
    volSlider.type = "range"
    volSlider.min = "0"
    volSlider.max = "100"
    volSlider.value = (app.appState.atcVolume.value * 100).toInt().toString()
    volSlider.className = "fv-atc__vol"
    volSlider.addEventListener("input", { _: Event ->
        app.audioPlayer.setVolume(volSlider.value.toInt() / 100.0)
    })
    container.appendChild(volSlider)

    container.button(className = "fv-btn fv-btn--ghost") {
        textContent = "Stop"
        onClick { app.audioPlayer.stop() }
    }

    fun render() {
        val stream = app.appState.atcStream.value
        if (stream == null) {
            container.asDynamic().style.display = "none"
            return
        }
        container.asDynamic().style.display = "flex"
        title.textContent = "${stream.airportCode} \u00B7 ${stream.feedName}"

        val status = app.appState.atcStatus.value
        statusSpan.className = "fv-atc__status" +
            if (status == AtcStreamStatus.ERROR) " error" else ""
        statusSpan.textContent = when (status) {
            AtcStreamStatus.LOADING -> "Connecting\u2026"
            AtcStreamStatus.PLAYING -> "Playing"
            AtcStreamStatus.STALLED -> "Buffering\u2026"
            AtcStreamStatus.ERROR -> "Error"
            null -> ""
        }
    }
    app.appState.scope.bindFlow(app.appState.atcStream) { render() }
    app.appState.scope.bindFlow(app.appState.atcStatus) { render() }
    app.appState.scope.bindFlow(app.appState.atcVolume) { v ->
        volSlider.value = (v * 100).toInt().toString()
    }
}
